import 'reflect-metadata';

import { isPlatformBrowser, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import { Inject, InjectionToken, Injector, NgModule, PLATFORM_ID, TransferState } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ElbuildCoreComponentsModule, ElbuildUiComponentslibModule } from 'elbuild-ui-componentslib';
import { AuthConfig, BaseAuthModule, ElbuildCoreServicesModule, ElbuildUiLibModule, SharedDataService } from 'elbuild-ui-lib-core';
import { ElbuildUiPaymentslibModule } from 'elbuild-ui-paymentslib';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Customer } from 'yf-commerce-model-ui-lib';
import { setAppInjector, StoreLibConfig, translateBrowserLoaderFactory, YfCommerceUiLibModule } from 'yf-commerce-ui-lib';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { MyAccountLoginComponent } from './my-account-login/my-account-login.component';

export const API_PREFIX = new InjectionToken<string>('API_PREFIX');

const authConfig: AuthConfig = {
	cookieprefix: 'YF-customer-' + environment.storecode,
	loginbase: 'access/customer',
	loginpage: 'account/login',
	domain: environment.shopURL,
	usertable: 'customer',
	userclass: Customer,
	i18napi: true,
	proxyfolder: environment.apiprefix,
	otherproxies: environment.externalapi ? [environment.externalapi] : undefined
};


export const libconfig: StoreLibConfig = {
	routes: undefined,
	homeroute: undefined, // PER PASSARE NUOVO COMPONENTE HOME
	theme: undefined,
	b2b: environment.b2b,
	storecode: environment.storecode,
	productlayout: undefined,
	collectionlayout: undefined,
	myaccountURL: undefined,
	checkoutURL: undefined,
	showpricefilter: undefined,
	showweigthfilter: undefined,
	collectionpagesize: undefined,
	maxprice: undefined,
	brandinfopage: undefined,
	version: undefined,
	completenewsletter: undefined,
	env: environment.production ? 'prod' : 'dev',
	themecolor: environment.themecolor,
	leftmenu: undefined,
	apiprefix: environment.apiprefix,
	relativeapiurl: undefined,
	apiurl: undefined,
	share: true,
	menu: undefined,
}


@NgModule({
	declarations: [
		AppComponent,
		MyAccountLoginComponent,
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		NgbModule,
		LoadingBarHttpClientModule,
		LoadingBarRouterModule,
		ToastrModule.forRoot({
			timeOut: 3000,
			progressBar: false,
			enableHtml: true,
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: translateBrowserLoaderFactory,
				deps: [HttpClient, API_PREFIX]
			}
		}),
		SharedModule,
		AppRoutingModule,
		YfCommerceUiLibModule.forRoot(libconfig),
		ElbuildUiLibModule.forRoot(authConfig),
		ElbuildUiComponentslibModule.forRoot(),
		ElbuildUiPaymentslibModule.forRoot(),
		ElbuildCoreComponentsModule,
		BaseAuthModule,
		ElbuildCoreServicesModule,
		NgxStripeModule.forRoot(),
	],
	providers: [provideHttpClient(withFetch(), withInterceptorsFromDi()),
	{ provide: API_PREFIX, useValue: environment.apiprefix },
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(injector: Injector, @Inject(PLATFORM_ID) private platformId: Object, private shareddataservice: SharedDataService) {
		if (isPlatformBrowser(this.platformId)) {
			setAppInjector(injector);
		} {
			//i18n lingua mettere le lingue supportate qui (localizedDatePipe)
			registerLocaleData(localeFr, 'fr');
			registerLocaleData(localeEs, 'es');
			registerLocaleData(localeDe, 'de');
			registerLocaleData(localeEn, 'en');
			registerLocaleData(localeIt, 'it');
			registerLocaleData(localePt, 'pt');

			this.shareddataservice.addCommonData('analyticsdebug', environment.analyticsdebug);
		}
	}
}
